module.exports = __webpack_public_path__ + "static/media/bottlings5.36e8e0fb.jpg";